import { api } from '../../shared/api/client';
import {
  type ListEnvelope,
  normalizeListEnvelope,
  toGenexusParams,
} from '../../shared/api/genexus-query';
import type { CrudApi } from '../../shared/api/crud-hooks';
import type { DataTableQuery } from '../../shared/components/DataTable';
import type { CompanyDto, CompanyInput, CompanyListItem } from './types';

const BASE = '/v1/companies';

export const companiesApi: CrudApi<CompanyListItem, CompanyDto, CompanyInput> = {
  async list(query: DataTableQuery): Promise<ListEnvelope<CompanyListItem>> {
    const { data } = await api.get<{
      data: CompanyListItem[];
      meta: { total: number; pagina?: number; porPagina?: number };
    }>(BASE, { params: toGenexusParams(query) });
    return normalizeListEnvelope(data);
  },

  async get(id: number): Promise<CompanyDto> {
    const { data } = await api.get<{ data: CompanyDto }>(`${BASE}/${id}`);
    return data.data;
  },

  async create(input: CompanyInput): Promise<CompanyDto> {
    const { data } = await api.post<{ data: CompanyDto }>(BASE, input);
    return data.data;
  },

  async update(id: number, input: CompanyInput): Promise<CompanyDto> {
    const { data } = await api.put<{ data: CompanyDto }>(`${BASE}/${id}`, input);
    return data.data;
  },

  async remove(id: number): Promise<void> {
    await api.delete(`${BASE}/${id}`);
  },
};
